import { FirestoreError } from 'firebase/firestore';

/**
 * 보안 규칙 거부를 다른 실패와 구분한다 (PLAN 5-12장 진단 보조).
 *
 * Firestore 클라이언트는 규칙 거부를 `permission-denied` 하나로 보고하지만,
 * 사용자에게 보여줄 문구는 원인이 뭐든 "다시 시도"가 정답이 아니다. 규칙 거부는
 * 재시도해도 같은 결과라서, 전용 문구로 바꿔 화면에 노출한다.
 *
 * AuthError와 구분이 필요하면 code 접두사(`auth/`)로 분기한다.
 */
export function isFirestorePermissionDenied(error: unknown): boolean {
  return error instanceof FirestoreError && error.code === 'permission-denied';
}

/**
 * 저장 대상 문서가 없음.
 *
 * `updatePin`은 `updateDoc`을 쓰는데, 이 API는 문서가 없으면 `not-found`로 실패한다.
 * 규칙 거부와는 전혀 다른 원인이지만 화면에는 둘 다 "다시 시도"로 보였고,
 * 재시도해도 결과가 같아 사용자는 빠져나갈 방법을 찾지 못했다.
 * 프로필 문서가 없으면 온보딩으로 되돌아가는 것이 정답이다.
 */
export function isFirestoreNotFound(error: unknown): boolean {
  return error instanceof FirestoreError && error.code === 'not-found';
}
